import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';
import { PazaramaOrder } from '../../interfaces/Pazarama/PazaramaOrder';
import {
  getDefaultPazaramaOrderFilter,
  PazaramaOrderFilter,
} from '../../interfaces/Pazarama/PazaramaOrderFilter';
import { getPazaramaOrders } from '../../api/Pazarama';
import { Pagination } from '../../interfaces/Pagination';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { PazaramaOrdersTable } from './PazaramaOrdersTable/PazaramaOrdersTable';

export const PazaramaOrdersPage = () => {
  const [orders, setOrders] = useState<PaginatedResponse<PazaramaOrder>>({
    data: [],
    totalCount: 0,
  });
  const [filter, setFilter] = useState(getDefaultPazaramaOrderFilter());
  const [loading, setLoading] = useState(false);

  const refreshOrders = (filters?: PazaramaOrderFilter) => {
    setLoading(true);
    getPazaramaOrders(filters ?? filter)
      .then((res) => setOrders(res))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshOrders();
  }, []);

  const handlePagination = (p: Pagination) => {
    const newFilter = { ...filter, pagination: p };

    setFilter(newFilter);
    refreshOrders(newFilter);
  };

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Waiting open={loading} />

      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Pazarama Siparişleri
      </Typography>

      <PazaramaOrdersTable
        orders={orders.data}
        totalCount={orders.totalCount}
        pagination={filter.pagination}
        onPagination={handlePagination}
      />
    </Box>
  );
};
